import { useState } from "react";
import { Modal, Button } from "react-bootstrap";

import useCaseStagesStatuses from "../hooks/useCaseStagesStatuses";
import FilterIcon from "../../../../assets/filter-icon-color.svg";
import stageIcon from "../../../../assets/icons/stageicon.svg";
import "./StageStatusFilterModal.css";

const StageStatusFilterModal = ({ show, onHide, onApplyFilter, currentFilter = null }) => {
  const { allCaseStages, allCaseStatuses } = useCaseStagesStatuses();

  const [selectedFilterType, setSelectedFilterType] = useState(currentFilter?.type || "none");
  const [selectedValue, setSelectedValue] = useState(currentFilter?.value || "");

  const handleRadioChange = (type, value = "") => {
    setSelectedFilterType(type);
    setSelectedValue(value);
  };

  const isStageSelected = (stage) =>
    selectedFilterType === "stage" && selectedValue === stage.id.toString();
  const isStatusSelected = (status) =>
    selectedFilterType === "status" && selectedValue === status.id.toString();

  const handleApplyFilter = () => {
    let filterData = null;

    if (selectedFilterType === "stage" && selectedValue) {
      const selectedStage = allCaseStages.find((stage) => stage.id.toString() === selectedValue);
      filterData = {
        type: "stage",
        value: selectedValue,
        name: selectedStage?.name || "",
      };
    } else if (selectedFilterType === "status" && selectedValue) {
      const selectedStatus = allCaseStatuses.find(
        (status) => status.id.toString() === selectedValue
      );
      filterData = {
        type: "status",
        value: selectedValue,
        name: selectedStatus?.name || "",
      };
    }

    onApplyFilter(filterData);
    onHide();
  };

  const getApplyButtonText = () => {
    if (selectedFilterType === "none") {
      return "Do Not Filter by Case Stage or Status";
    } else if (selectedFilterType === "stage" && selectedValue) {
      const selectedStage = allCaseStages.find((stage) => stage.id.toString() === selectedValue);
      return `Filter by ${selectedStage?.name || "Selected"} Stage`;
    } else if (selectedFilterType === "status" && selectedValue) {
      const selectedStatus = allCaseStatuses.find(
        (status) => status.id.toString() === selectedValue
      );
      return `Filter by ${selectedStatus?.name || "Selected"} Status`;
    }
    return "Apply Filter";
  };

  return (
    <Modal show={show} onHide={onHide} centered size="lg" dialogClassName="modal-stages-statuses">
      <Modal.Header
        className="document-modal-header d-flex align-items-center justify-content-center height-25"
        style={{ borderRadius: "0px" }}
      >
        <Modal.Title
          id="contained-modal-title-vcenter"
          style={{
            fontSize: "14px",
            fontWeight: "600",
            textTransform: "uppercase",
          }}
          className="d-flex align-items-center justify-content-center height-25"
        >
          Filter by Case Stage or Case Status
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="p-0">
        {/* No Filter Section */}
        <div
          className="d-flex align-items-center justify-content-center m-b-5 m-t-5"
          style={{ height: "25px" }}
        >
          <div className="d-flex align-items-center" style={{ gap: "5px" }}>
            <input
              className="form-check mb-0 "
              type="radio"
              name="filterOption"
              id="noFilter"
              style={{
                minHeight: "13px",
              }}
              checked={selectedFilterType === "none"}
              onChange={() => handleRadioChange("none")}
            />
            <label className="form-check-label mb-0" htmlFor="noFilter">
              Do Not Filter by Case Stage or Case Status
            </label>
          </div>
        </div>

        {/* Stage Filter Section */}
        <div className="m-b-5">
          <div
            className="bg-primary text-white height-25 p-l-5 m-b-5"
            style={{
              fontSize: "14px",
              fontWeight: "600",
              borderRadius: "0px",
            }}
          >
            Filter by Active Case Stage:
          </div>

          <div className="stage-filter-grid p-l-5 p-r-5">
            {allCaseStages.map((stage) => (
              <div key={stage.id} className="stage-filter-option">
                <input
                  className="form-check mb-0"
                  type="radio"
                  name="filterOption"
                  id={`stage-${stage.id}`}
                  style={{
                    minHeight: "13px",
                  }}
                  checked={isStageSelected(stage)}
                  onChange={() => handleRadioChange("stage", stage.id.toString())}
                />
                <label className="mb-0 stage-search-label" htmlFor={`stage-${stage.id}`}>
                  <span
                    className="d-flex align-items-center justify-content-center m-r-5"
                    style={{
                      width: "19px",
                      height: "19px",
                    }}
                  >
                    <img
                      style={{ height: "15px", width: "15px" }}
                      src={stageIcon}
                      alt="stage-icon"
                    />
                  </span>
                  <span className="stage-search-label-text">{stage.name}</span>
                </label>
              </div>
            ))}
          </div>
        </div>

        {/* Status Filter Section */}
        <div className="m-b-5">
          <div
            className="bg-primary text-white p-l-5 height-25 m-b-5"
            style={{
              fontSize: "14px",
              fontWeight: "600",
              borderRadius: "0px",
            }}
          >
            Filter by Active Case Status:
          </div>

          <div className="d-flex flex-wrap mx-auto p-l-5 p-r-5">
            {allCaseStatuses.map((status) => (
              <div key={status.id} className="col-md-3 col-lg-3 m-b-5">
                <div className="d-flex align-items-center" style={{ gap: "5px" }}>
                  <input
                    className="form-check mb-0"
                    type="radio"
                    style={{
                      minHeight: "13px",
                    }}
                    name="filterOption"
                    id={`status-${status.id}`}
                    checked={isStatusSelected(status)}
                    onChange={() => handleRadioChange("status", status.id.toString())}
                  />
                  <label className="mb-0 status-filter-wrap" htmlFor={`status-${status.id}`}>
                    <span
                      className={`status-filter-btn${
                        isStatusSelected(status) ? " is-selected" : ""
                      }`}
                    >
                      <span className="status-filter-label">{status.name}</span>
                    </span>
                  </label>
                </div>
              </div>
            ))}
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer
        className=" p-0 mt-0 padding-outside-btn-new-provider"
        style={{
          borderTop: "none",
        }}
      >
        <Button
          variant="secondary"
          className="button-padding-footer-new-provider d-flex align-items-center justify-content-center  btn btn-secondary"
          onClick={onHide}
        >
          Cancel
        </Button>
        <Button
          variant="success"
          onClick={handleApplyFilter}
          className="button-padding-footer-new-provider d-flex align-items-center justify-content-center  btn btn-secondary"
        >
          {getApplyButtonText()}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

// Helper component for the filter tab button
export const FilterTabButton = ({ currentFilter, onClick }) => {
  const getFilterLabel = () => {
    if (!currentFilter) {
      return (
        <>
          <span className="ic-avatar d-flex align-items-center m-r-5 ic-15">
            <img src={FilterIcon} width="15" alt="Filter" />
          </span>
          Stage / Status
        </>
      );
    } else if (currentFilter.type === "stage") {
      return (
        <>
          <span className="ic-avatar d-flex align-items-center m-r-5 ic-15">
            <img src={FilterIcon} width="15" alt="Filter" />
          </span>
          Showing Cases in {currentFilter.name} Stage
        </>
      );
    } else if (currentFilter.type === "status") {
      return (
        <>
          <span className="ic-avatar d-flex align-items-center m-r-5 ic-15">
            <img src={FilterIcon} width="15" alt="Filter" />
          </span>
          Showing Cases With {currentFilter.name} Status
        </>
      );
    }
  };

  return (
    <button
      className="btn btn-outline-primary d-flex align-items-center"
      onClick={onClick}
      style={{
        borderRadius: "4px",
        fontSize: "14px",
        fontWeight: "500",
      }}
    >
      {getFilterLabel()}
    </button>
  );
};

export default StageStatusFilterModal;
